import { combineReducers } from 'redux';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { TASK_KEY } from '../../../services/FacilitatorValidationService';
import actions from './actions';
import * as fromDelay from './actions/delay';
import * as fromDone from './actions/done';
import content from './content';
import filters from './filters';
import * as fromDomains from './filters/domains';

export default combineReducers({
  filters,
  content,
  actions,
});

export const getFacilitatorValidationActionsAreLoading = state =>
  getFacilitatorValidationDelayIsLoading(state) ||
  getFacilitatorValidationDoneIsLoading(state);

export const getFacilitatorValidationDomains = state =>
  fromDomains.getFacilitatorValidationDomains(
    state.tasks.facilitatorValidation.filters.domains
  );

export const getFacilitatorValidationDomainsIsLoading = state =>
  state.tasks.facilitatorValidation.filters.domains.isLoading;

export const getFacilitatorValidationSelectedDomainId = state =>
  state.tasks.facilitatorValidation.filters.selected.domainId;

export const getFacilitatorValidationSelectedFilterByCustomer = state =>
  state.tasks.facilitatorValidation.filters.selected.filterByCustomer;

export const getFacilitatorValidationFiltersSelected = state =>
  state.tasks.facilitatorValidation.filters.selected;

export const getFacilitatorValidationLinkTaskRequest = state =>
  state.tasks.facilitatorValidation.content.linkTaskRequest.response?.data ||
  {};

export const getFacilitatorValidationLinkTaskRequestIsLoading = state =>
  state.tasks.facilitatorValidation.content.linkTaskRequest.isLoading;

export const getFacilitatorValidationContentLinks = state => {
  let contentLinksData = {};
  const doneData = getFacilitatorValidationDone(state);

  const status = doneData.response?.status || doneData.error?.status;

  if (status === HttpStatus.OK.value) {
    contentLinksData = doneData.response?.data ?? {};
  } else if (status === HttpStatus.CALL_FAILURE.value) {
    contentLinksData = doneData.error?.data ?? {};
  }

  return Object.keys(contentLinksData)
    .filter(key => contentLinksData[key].key !== TASK_KEY)
    .map(key => ({
      isSuccess: contentLinksData[key]?.status === HttpStatus.CREATED.value,
      message: contentLinksData[key].error?.message ?? null,
      text: contentLinksData[key].key,
    }));
};

export const getFacilitatorValidationContentLinkUrls = state =>
  state.tasks.facilitatorValidation.content.contentLinkUrls || null;

export const getFacilitatorValidationDelayIsLoading = state =>
  state.tasks.facilitatorValidation.actions.delay.isLoading;

export const getFacilitatorValidationDelayIsSuccess = state =>
  fromDelay.getFacilitatorValidationDelayIsSuccess(
    state.tasks.facilitatorValidation.actions.delay
  );

export const getFacilitatorValidationDone = state =>
  state.tasks.facilitatorValidation.actions.done;

export const getFacilitatorValidationDoneIsLoading = state =>
  state.tasks.facilitatorValidation.actions.done.isLoading;

export const getFacilitatorValidationDoneIsSuccess = state =>
  fromDone.getFacilitatorValidationDoneIsSuccess(
    state.tasks.facilitatorValidation.actions.done
  );

export const getFacilitatorValidationDoneIsTaskFailed = state =>
  fromDone.getFacilitatorValidationDoneIsTaskFailed(
    state.tasks.facilitatorValidation.actions.done
  );
